;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.readyNowExpand = (function () {
    const initialize = function () {
      $('.jsOpenPrepopTopForm').click(function (e) {
        e.preventDefault()

        // Trigger a click of the button at the top
        const topButton = $('.masthead_module a.js-dropUpButton')
        topButton.click()

        // animate scrollback up to form at top
        $('html,body').animate({ scrollTop: topButton.offset().top - 100 }, 500)
      })

      $('.jsOpenPrepopTopFormCommunity, .jsFooterOpenPrepopTopFormCommunity').click(function (e) {
        e.preventDefault()

        let thisCommunity = null
        let thisAgent = null
        // Prepopulate the text area of the form with info about this request.
        if ($(this).hasClass('jsFooterOpenPrepopTopFormCommunity')) {
          thisCommunity = $(this).parents('.agentsContactDiv').find('.community-name').text()
          thisAgent = $(this).parents('.agentsContactDiv').find('.agent-name').text()
        } else {
          thisCommunity = $(this).parents('.community-rnh').find('.community-name').text()
          thisAgent = $(this).parents('.community-rnh').find('.agent-name').text()
        }
        $('#ninja_forms_field_15').text('ATTN ' + thisAgent + ': I would like information about home lots in ' + thisCommunity + '.')

        // Trigger a click of the button at the top
        const topButton = $('.masthead_module a.js-dropUpButton')
        topButton.click()

        // animate scrollback up to form at top
        $('html,body').animate({ scrollTop: topButton.offset().top - 100 }, 500)
      })

      $('.jsOpenPrepopTopFormLocation').click(function (e) {
        e.preventDefault()

        // Prepopulate the text area of the form with info about this request.
        const thisLocation = $(this).parents('.button').siblings('.location-name').text()
        $('#ninja_forms_field_15').text('I would like information about future home lots in ' + thisLocation + '.')

        // Trigger a click of the button at the top
        const topButton = $('.masthead_module a.js-dropUpButton')
        topButton.click()

        // animate scrollback up to form at top
        $('html,body').animate({ scrollTop: topButton.offset().top - 100 }, 500)
      })

      $('.jsOpenPrepopTopFormLot').click(function (e) {
        e.preventDefault()

        // Prepopulate the text area of the form with info about this request.
        const thisAddress = $('.lot-address').text()
        const thisAgent = $('.lot-agent-name').text()
        const thisCommunity = $('.full-community-name').text()
        $('#ninja_forms_field_15').text('ATTN ' + thisAgent + ': I would like more information about visiting ' + thisAddress + ' in ' + thisCommunity + '.')

        // Trigger a click of the button at the top
        const topButton = $('.masthead_module a.js-dropUpButton')
        topButton.click()

        // animate scrollback up to form at top
        $('html,body').animate({ scrollTop: topButton.offset().top - 100 }, 500)
      })

      $('.ready-now-search-form input').change(function (e) {
        // e.preventDefault();
        // console.log($(this).prop("checked"));
        if ($(this).prop('checked')) {
          if ($(this).attr('id') === 'view-all') {
            // console.log("view all!");
            $('.ready-now-search-form input').not('#view-all').prop('checked', false)
            $('.ready-now-search-form label.is-selected').removeClass('is-selected')
          } else {
            $('.ready-now-search-form .view-all input').prop('checked', false)
            $('.ready-now-search-form .view-all').removeClass('is-selected')
          }
          $(this).parent('label').addClass('is-selected')
        } else {
          $(this).parent('label').removeClass('is-selected')
        }
      })

      $('.community-rnh .expand-toggle').click(function (e) {
        const self = $(this)

        if ($(this).parents('.community-rnh').hasClass('expanded')) {
          $(this).parents('.community-rnh').removeClass('expanded')
        } else {
          try {
            // console.log("Push State " + self.attr('href'));
            window.history.pushState({}, '', self.attr('href'))
            e.preventDefault()
          } catch (err) {
            // Let the jump happen normally.
          }

          $('.community-rnh').removeClass('expanded')
          $(this).parents('.community-rnh').addClass('expanded')
          setTimeout(function () { $('html,body').animate({ scrollTop: (self.parents('.community-rnh').offset().top - 50) }) }, 200)
        }
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.readyNowExpand.initialize()
  })
}(jQuery, window))
